import { TableCell, TableRow, withStyles } from "@material-ui/core"
import moment from "moment"
import React, { Component } from "react"

import Icon from "@material-ui/core/Icon"

import { Dictionary } from "../../classes/Dictionary"
import { ExpandRows, TableRowToggleEvent } from "../../classes/Helper"
import DataTable from "../../components/DataTable"
import HandyRustyStore from "../../stores/HandyRustyStore"
import { errorHandler } from "../../stores/helpers"
import SessionStore from "../../stores/SessionStore"
import theme from "../../theme"
import LoggerRow from "./LoggerRow"
import isSkipFcntChecker from "./isSkipFcntChecker"

const styles = {
  chart: {
    width: 380,
  },
  tabs: {
    borderBottom: "1px solid " + theme.palette.divider,
    height: "48px",
    overflow: "visible",
  },
}

function parseTxInfo(txInfo) {
  if (!txInfo) return null
  if (typeof txInfo === "string") {
    try {
      return JSON.parse(txInfo)
    } catch (error) {
      return null
    }
  }
  return txInfo
}

function detectRxWindow(txInfo, uplinkFrequency) {
  if (!txInfo) return ""

  const delaySeconds = txInfo?.TimingInfo?.DelayTimingInfo?.delay?.seconds
  if (delaySeconds === 1) return "RX1"
  if (delaySeconds === 2) return "RX2"

  if (txInfo.frequency && uplinkFrequency && txInfo.frequency === uplinkFrequency) {
    return "RX1"
  }

  if (txInfo.frequency === 869525000) {
    return "RX2"
  }

  return ""
}

function appendRxWindow(rows) {
  const lastUplinkFrequencyByDevAddr = {}

  return rows
    .slice()
    .reverse()
    .map((item) => {
      const devAddr = item.devAddr
      const parsedTxInfo = parseTxInfo(item.txInfo)
      let rxWindow = item.rxWindow || ""

      if (item.direction === "RX" && parsedTxInfo?.frequency && devAddr) {
        lastUplinkFrequencyByDevAddr[devAddr] = parsedTxInfo.frequency
      }

      if (item.direction === "TX") {
        rxWindow = detectRxWindow(parsedTxInfo, devAddr ? lastUplinkFrequencyByDevAddr[devAddr] : undefined)
      }

      return { ...item, rxWindow }
    })
    .reverse()
}

// let canLoad = false

class ListWirelessLoggerTable extends Component {
  constructor() {
    super()
    this.getPage = this.getPage.bind(this)
    this.getRow = this.getRow.bind(this)
    this.onPaginationNextPrev = this.onPaginationNextPrev.bind(this)
    this.resetTotal = this.resetTotal.bind(this)
    this.expandAllChange = this.expandAllChange.bind(this)
    this.dict = new Dictionary("diagnostics-table-head")
    this.state = {
      page: 0,
      expandAll: false,
    }
    this.action = null
    this.total = null
    this.firstLoad = true
  }
  onPaginationNextPrev(action) {
    this.action = action
  }
  expandAllChange(ev) {
    ev.persist()

    this.setState({ expandAll: !this.state.expandAll }, () => {
      let icon = ev.target
      let arr = ["fa-minus-circle", "fa-plus-circle"]
      if (this.state.expandAll) {
        arr.reverse()
        ExpandRows(true)
      } else {
        ExpandRows(false)
      }
      icon.className = icon.className.replace(...arr)
    })
  }

  getPage(limit, offset, callbackFunc) {
    let filter = Object.assign({}, this.props.filter)
    let query_string = window.location.hash.split("?")[1]

    if (query_string) {
      let searchParams = new URLSearchParams(query_string)

      if (searchParams.has("organizationId")) filter["organizationId"] = parseInt(searchParams.get("organizationId"))
      if (searchParams.has("start")) filter["start"] = searchParams.get("start")
      if (searchParams.has("end")) filter["end"] = searchParams.get("end")
      if (filter["filters"] === undefined) filter["filters"] = {}
      if (searchParams.has("gw")) filter["filters"]["gw"] = searchParams.get("gw")
      if (searchParams.has("devAddr")) filter["filters"]["devAddr"] = searchParams.get("devAddr")
      if (searchParams.has("mType")) filter["filters"]["mType"] = searchParams.get("mType")
      if (searchParams.has("direction")) filter["filters"]["direction"] = searchParams.get("direction")

      if (searchParams.has("devEUI")) {
        filter["filters"]["devEUI"] = searchParams.get("devEUI")
        if (!SessionStore.isAdmin() && SessionStore.organizations.filter((el) => el.isDeviceAdmin).length > 1) {
          SessionStore.globalSearch(filter["filters"]["devEUI"], 1, 0, (resp) => {
            if (resp.totalCount > 0 && resp.result[0].organizationID !== SessionStore.getOrganizationID()) {
              errorHandler({ message: "Device is out of scope current organization or not found." })
            }
          })
        }
      }
    }

    // if (canLoad === true) {
    // setTimeout(() => {

    ExpandRows(this.state.expandAll, () => {
      // canLoad = false
      let rowsPerPage = SessionStore.getRowsPerPage()
      if (this.data && this.data.length > 0) {
        if (this.action && this.action === "forward") {
          // filter["end"] = moment(this.data[this.data.length-1].dateTime).toISOString()
          limit = rowsPerPage
          // offset = this.state.page * limit
        }

        if (this.action && this.action === "backward") {
          // filter["order"] = "ASC";
          // filter["reverse"] = true;
          // filter["start"] = moment(this.data[0].dateTime).toISOString()
          limit = rowsPerPage
        }

        if (this.action && this.action === "first") {
          this.firstLoad = true
        }
      }

      filter["getTotal"] = false
      if (this.firstLoad) {
        this.firstLoad = false
        this.resetTotal()
        limit = rowsPerPage
        filter["getTotal"] = true
      }

      HandyRustyStore.getDeviceFrames(filter, limit, offset, (obj) => {
        // canLoad = true
        this.action = null
        this.data = obj.result
        const devEUI = filter?.filters?.devEUI
        const devAddr = filter?.filters?.devAddr
        if (devEUI || devAddr) {
          let lastUplinkDateTime
          const result = obj.result
            .reverse()
            .map((item, index) => {
              if (item.direction === "RX") {
                const dateTime = item.dateTime
                const el = { ...item, delta: lastUplinkDateTime ? moment(dateTime) - moment(lastUplinkDateTime) : null }
                lastUplinkDateTime = dateTime
                return el
              } else return { ...item, delta: null }
            })
            .reverse()
          obj.result = result
        }

        obj.result = appendRxWindow(obj.result)
        obj.result = isSkipFcntChecker(obj.result)
        
        if (this.total === null) {
          this.total = obj.totalCount
        }
        obj.totalCount = this.total
        callbackFunc(obj)
      })
    })

    // }, 5)
    // }
  }

  resetTotal() {
    this.total = null
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    let props = Object.entries(this.props)
    for (const [key, value] of props) {
      if (nextProps[key] !== value) {
        return true
      }
    }
    return false
  }

  getRow(data, key) {
    return (
      <LoggerRow
        key={key}
        expandAll={this.state.expandAll}
        handleToggleClick={(ev) => {
          TableRowToggleEvent(ev, this.props.disableAutoUpdate)
        }}
        fields={this.props.fields}
        data={data}
      />
    )
  }

  render() {
    return (
      <DataTable
        ref={this.props.tableRef}
        changePageEvent={this.props.changePageEvent}
        fields={this.props.fields}
        paginationTools={["forward", "backward", "first", "pageTotal", "paginator"]}
        total={this.state.total}
        maxpage={false}
        onPaginationNextPrev={this.onPaginationNextPrev}
        header={
          <TableRow className={"head-container"}>
            <TableCell className={"cell"}>
              <Icon
                onClick={this.expandAllChange}
                title={"Expand all"}
                style={{
                  fontSize: 15,
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                className={"fa fa-plus-circle"}
              />
            </TableCell>
            {this.props.fields &&
              this.props.fields.map((field, i) => {
                return (
                  <TableCell style={{ paddingBottom: "10px" }} key={i} className={"header-name pd after"}>
                    {field.head.render()}
                  </TableCell>
                )
              })}
          </TableRow>
        }
        getPage={this.getPage}
        getRow={this.getRow}
      />
    )
  }
}

export default ListWirelessLoggerTable = withStyles(styles)(ListWirelessLoggerTable)
